import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import { LfsaBotonEditarGridComponent } from '../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';

import { EmpleadoModel } from 'src/app/aplicaciones-modulos/emp-terceros/models/empleadoModel';
import { comedorModulo } from '../../diccionarios/comedorModulo';
import { ComedorService } from '../../services/comedor.services';
import { UtilsService } from 'src/app/shared/utils/utils.service';

@Component({
  selector: 'app-mantener-programa-nutricion',
  templateUrl: './mantener-programa-nutricion.component.html',
  styleUrls: ['./mantener-programa-nutricion.component.css']
})

export class MantenerProgramaNutricionComponent implements OnInit {
  public DAT_TITULOS = comedorModulo.titulos.empleados;
  public DAT_AG_GRID = comedorModulo.agGrid;

  public titleModal   : string;
  public loading      : boolean = false;
  public isCreate     : boolean = true;
  public empleado     : EmpleadoModel;

  public frameworkComponents: any;
  public columnDefs  : any[] = [];
  public rowData     : any[] = [];
  public rowSelection: any;
  public gridApi     : any;
  public gridColumnApi:any;
  public textoBuscar  : string;


  public formulario = new FormGroup({
    cedula   : new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]),
    nombres   : new FormControl('', [Validators.required]),
    dscaLocalidad: new FormControl('', [Validators.required]),
    statusEmpleado   : new FormControl('', [Validators.required])
    });

  constructor(
    private comedorServices : ComedorService,
    private utilServices    : UtilsService
  ) { }

  ngOnInit(): void {
    this.cargarGridcomponent();
    this.listar();
  }

  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent, };

    this.columnDefs = [
      { filter: true, resizable: true, field: 'cedula'  },
      { filter: true, resizable: true, field: 'nombres' },
      { filter: true, resizable: true, field: 'dscaLocalidad'},
      { filter: true, resizable: true, field: 'statusEmpleado'},
      { cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          onClick: this.ver.bind(this),
          label: 'Editar', classBtn: 'btn btn-danger', iconBtn: 'fa fa-eye'
        },
      },
      { cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: 'Eliminar', classBtn: 'btn btn-danger', iconBtn: 'fa fa-trash'
        },
      }
    ];
    
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  listar(){
    this.comedorServices.getAllEmpleadosDieta().subscribe((res) => {
      if(res){
        this.rowData = res;
      }else{
        this.utilServices.mensajeOKToast("No se encontraron regitros", 3000);
        this.rowData =[];
      }
    }, (err) => { 
      console.log(err.message); 
    });
  }

  nuevo() {
    this.isCreate   = true;
    this.titleModal = this.DAT_TITULOS.tituloAgregar;
    
    this.formulario.reset();
    this.openModal();
  }

  ver({rowData}){
    this.isCreate   = false;
    this.titleModal = this.DAT_TITULOS.tituloActualizar;

    this.formulario.reset();
    this.formulario.patchValue(rowData);
    this.openModal();
  }

  eliminar({rowData}){
    this.loading = true;
    let eliminar = {"cedula": rowData.cedula}; 

    this.utilServices.confirmarSincronoPromesa({
        title : comedorModulo.mensajes.eliminar,
        text  : this.DAT_TITULOS.tituloEliminar,
        action: "Eliminar",
        funcion: this.comedorServices.deleteEmpleadosDieta(eliminar),
      })
      .then((_res: any) => {
        this.listar();
      })
      .catch(() => {
        this.loading = false;
      });

    this.loading = false;
  }

  saveForm() {
    if (this.formulario.invalid) return;

    this.loading = true;
    let mensajeP = this.isCreate ? comedorModulo.mensajes.guardar : comedorModulo.mensajes.actualizar;
    const payload = this.formulario.getRawValue();

    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        funcion : this.comedorServices.postEmpleadosDieta(payload)
      })
      .then(() => {
        this.listar();
        this.closeModal();
      })
      .catch(() => {
      });

      this.loading = false;
  }

  getEmpleado(event){
    let cedula = this.formulario.get('cedula').value;
    
    this.formulario.get('nombres').reset();
    this.formulario.get('dscaLocalidad').reset();
    this.formulario.get('statusEmpleado').reset();

    this.comedorServices.getEmpleadoByCedula(cedula).subscribe((res) => {
      if(res){
        this.empleado = res;

        if(this.empleado.statusEmpleado != "Activo" && this.isCreate && this.empleado.empresa.codEmpresa == 'FABR' && this.empleado.tipoEmpleado == 'COLABORADOR'){
          this.utilServices.mensajeErroToast("Empleado Inactivo", 3000);
          this.empleado = null;
          return
        }
        
        this.formulario.get('nombres').setValue(this.empleado.nombres);
        this.formulario.get('dscaLocalidad').setValue(this.empleado.codLocalidad + " - " + this.empleado.dscaLocalidad);
        this.formulario.get('statusEmpleado').setValue(this.empleado.statusEmpleado);

      }else{
        this.utilServices.mensajeOKToast("No se encontró empleado", 3000);
        this.empleado = null;
      }
    }, (err) => { 
      console.log(err.message); 
    });

  }

  acciones(event) {
    console.log("acciones", event);
    if (event === 'regresar') return this.closeModal();
    this.saveForm();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  onKeydown(event) {
    console.log(event);

    if ((event.key === 'Enter' && this.formulario.valid === true)){
        console.log('ENTER --> KEYDOWN');
      }

  }

}
